import { Button, StylovyzeComposableDialog } from '@innovyze/stylovyze';
import React from 'react';

import { useGlobalization } from '@Translations';
import { NewIntegrationContainer } from '../../IntegrationsTab.styles';
import { VaparAuthDialogContainer } from './VaparSettings.styles';

interface VaparAuthFailedDialogProps {
	open: boolean;
	onCancel: () => void;
}

export default function VaparAuthFailedDialog({
	open,
	onCancel,
}: VaparAuthFailedDialogProps) {
	const { t } = useGlobalization();
	return (
		<StylovyzeComposableDialog
			title={t('Authentication Failed')}
			onCancel={onCancel}
			open={open}>
			<NewIntegrationContainer>
				<VaparAuthDialogContainer>
					Authentication failed, try again
				</VaparAuthDialogContainer>
				<div>
					<Button
						dataCy="cancelButton"
						color="secondary"
						variant="contained"
						onClick={() => {
							onCancel();
						}}>
						{t('Close')}
					</Button>
				</div>
			</NewIntegrationContainer>
		</StylovyzeComposableDialog>
	);
}
